<template>
  <q-layout view="hHh LpR lFf">
    <q-header elevated class="bg-primary text-white" v-if="isLogged && !isInIframe">
      <q-toolbar>
        <q-btn dense flat round icon="menu" @click="left = !left" />

        <q-toolbar-title>
          SRCAL - {{currentRouteLabel}}
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-drawer v-model="left" side="left" overlay bordered v-if="isLogged && !isInIframe">
      <q-scroll-area style="height: calc(100% - 150px); margin-top: 150px; border-right: 1px solid #ddd">
        <q-list bordered>
          <q-item clickable v-ripple to="/" exact>
            <q-item-section avatar>
              <q-icon name="house" />
            </q-item-section>
            <q-item-section>
              Início
            </q-item-section>
          </q-item>
          <q-item clickable v-ripple to="/usuario" exact v-if="usuarioLogado.nivel === 'ADMIN'">
            <q-item-section avatar>
              <q-icon name="person" />
            </q-item-section>
            <q-item-section>
              Cadastro de Usuários
            </q-item-section>
          </q-item>
          <q-item clickable v-ripple to="/pesquisas" exact v-if="usuarioLogado.nivel === 'ADMIN'">
            <q-item-section avatar>
              <q-icon name="question_answer" />
            </q-item-section>
            <q-item-section>
              Pesquisas
            </q-item-section>
          </q-item>
          <q-item clickable v-ripple @click="modalPassword = true" >
            <q-item-section avatar>
              <q-icon name="vpn_key" />
            </q-item-section>
            <q-item-section>
              Alterar Senha
            </q-item-section>
          </q-item>
          <q-item clickable v-ripple class="text-red" @click.prevent="logout">
            <q-item-section avatar>
              <q-icon name="exit_to_app" />
            </q-item-section>
            <q-item-section>
              Logoff
            </q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>
      <q-img class="absolute-top" src="https://cdn.quasar.dev/img/material.png" style="height: 150px">
        <div class="absolute-bottom bg-transparent">
          <q-avatar size="56px" class="q-mb-sm" color="primary" text-color="white">
            {{iniciais}}
          </q-avatar>
          <div class="text-weight-bold">{{usuarioLogado.nome}}</div>
          <div>{{usuarioLogado.email}}</div>
        </div>
      </q-img>
    </q-drawer>

    <q-page-container>
      <q-dialog :value="true" v-if="modalPassword" persistent>
        <q-card>
          <q-card-section class="row items-center q-pb-none">
            <div class="text-h6">Alterar minha Senha</div>
            <q-space />
            <q-btn icon="close" flat round dense @click="modalPassword = false" />
          </q-card-section>
          <q-card-section>
            <update-password ref="formChangePassword" @passwordUpdated="onPasswordUpdated"></update-password>
          </q-card-section>
        </q-card>
      </q-dialog>
      <slot></slot>
    </q-page-container>

  </q-layout>
</template>

<script>
import UpdatePassword from './Usuario/UpdatePassword'
export default {
  name: 'nav-bar',
  data () {
    return {
      left: false,
      modalPassword: false
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('setToken', '')
      this.$store.dispatch('setUsuario', {})
      this.$router.push({ name: 'Login' })
    },

    onHide () {
      // console.log('Modal fechado')
    },

    onPasswordUpdated () {
      this.modalPassword = false
    }
  },
  computed: {
    isLogged () {
      return !!this.$store.getters.getToken
    },
    usuarioLogado () {
      return this.$store.getters.getUsuario
    },
    message () {
      return this.$store.getters.getMessage
    },
    isInIframe () {
      return this.$store.getters.getInIframe
    },
    iniciais () {
      if (!this.usuarioLogado.nome) return ''
      return this.usuarioLogado.nome
        .toUpperCase()
        .split(' ')
        .filter((_, idx, self) => idx === 0 || idx === self.length-1)
        .map(x => x.substr(0, 1))
        .join('')
    },

    currentRouteLabel () {
      const { meta: { label = '' } = {} } = this.$route
      return label
    }
  },
  components: {
    UpdatePassword
  },
  watch: {
    message (message) {
      if (message) {
        this.$bvToast.toast(message, {
          title: 'SRCAL',
          variant: 'success',
          solid: true
        })
      }
      this.$store.dispatch('setMessage', '')
    }
  }
}
</script>

<style scoped>
  .bg-success {
    background-color: #265f43 !important;
  }

  .navbar-dark .navbar-brand {
    color: #f0b022;
  }
</style>